import React, { ReactNode } from 'react'
import { Typography } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'
import { tokens } from '../../styles/tokens'

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(0.5),
    color: tokens.color.neutral[900],
    fontSize: '0.8rem',
    paddingTop: theme.spacing(2),
    fontWeight: 600,
  },
}))

interface Props {
  contentTitle: string
  actionButtons?: ReactNode
}

export const ContentTitle: React.FC<Props> = ({ contentTitle, actionButtons }) => {
  const classes = useStyles()
  return (
    <Typography color="primary" className={classes.root}>
      {contentTitle}
      {actionButtons}
    </Typography>
  )
}
